/** Шрифт представления о ЛП (как в эталонном Word). */
export const PRESENTATION_FONT = 'Times New Roman'

export function withPresentationFont(textRunOptions = {}) {
  return {
    font: PRESENTATION_FONT,
    ...textRunOptions,
  }
}
